import { PaginatorDesignTokens } from '@primeuix/themes/aura/paginator';

export const paginatorTokens: PaginatorDesignTokens = {
  root: {
    padding: '0.5rem 1rem',
    gap: '0.25rem',
    borderRadius: '{content.border.radius}',
    background: '{content.background}',
    color: '{content.color}',
    transitionDuration: '{transition.duration}',
  },
  navButton: {
    background: 'transparent',
    hoverBackground: '{indigo.50}',
    hoverColor: '{indigo.950}',
    selectedBackground: '{highlight.background}',
    selectedColor: '{indigo.950}',
    width: '2.5rem',
    height: '2.5rem',
    borderRadius: '{paginator.nav.button.width} / 2',
    color: '{indigo.950}',
    focusRing: {
      width: '{focus.ring.width}',
      style: '{focus.ring.style}',
      color: '{indigo.700}',
      offset: '{focus.ring.offset}',
      shadow: '{focus.ring.shadow}',
    },
  },
  currentPageReport: {
    color: '{text.muted.color}',
  },
  jumpToPageInput: {
    maxWidth: '2.5rem',
  },
  colorScheme: {
    light: {
      navButton: {
        selectedBackground: '{primary.50}',
        selectedColor: '{primary.950}',
      },
    },
    dark: {
      navButton: {
        color: '{surface.0}',
        selectedBackground: '{primary.900}',
        selectedColor: '{surface.0}',
      },
    },
  },
};
